import * as ActionType from 'constants/action-types/organization';

export default (state, { type, payload }) => {
  switch (type) {
    case ActionType.MODIFY_BULK_PAYMENT_RECIPIENT_START:
      return {
        ...state,
        modifyBulkPaymentRecipient: {
          ...state.modifyBulkPaymentRecipient,
          loading: true,
          error: null,
        },
      };
    case ActionType.MODIFY_BULK_PAYMENT_RECIPIENT_SUCCESS:
      return {
        ...state,
        modifyBulkPaymentRecipient: {
          ...state.modifyBulkPaymentRecipient,
          data: payload,
          error: null,
          loading: false,
        },
      };
    case ActionType.MODIFY_BULK_PAYMENT_RECIPIENT_ERROR:
      return {
        ...state,
        modifyBulkPaymentRecipient: {
          ...state.modifyBulkPaymentRecipient,
          data: payload,
          error: null,
          loading: false,
        },
      };

    default:
      return null;
  }
};
